// extracted by mini-css-extract-plugin
module.exports = {"FAQ_section":"FAQs_FAQ_section__2AIzc","addLink":"FAQs_addLink__185Tl","conversationText":"FAQs_conversationText__3rbvL","inputTextare":"FAQs_inputTextare__2Xh8F"};